import { ref, onMounted } from "vue";

type Theme = "light" | "dark";

const theme = ref<Theme>("light");

function applyTheme(value: Theme) {
  theme.value = value;
  document.documentElement.setAttribute("data-theme", value);
  localStorage.setItem("theme", value);
}

function detectSystemTheme(): Theme {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

function initTheme() {
  const savedTheme = localStorage.getItem("theme") as Theme | null;

  if (savedTheme === "light" || savedTheme === "dark") {
    applyTheme(savedTheme);
  } else {
    applyTheme(detectSystemTheme());
  }
}

function toggleTheme() {
  applyTheme(theme.value === "dark" ? "light" : "dark");
}

function watchSystemTheme() {
  const media = window.matchMedia("(prefers-color-scheme: dark)");

  const handler = (e: MediaQueryListEvent) => {
    const savedTheme = localStorage.getItem("theme");

    if (!savedTheme) {
      applyTheme(e.matches ? "dark" : "light");
    }
  };

  media.addEventListener("change", handler);

  return () => media.removeEventListener("change", handler);
}

export function useTheme() {
  onMounted(() => {
    initTheme();
  });

  return {
    theme,
    applyTheme,
    toggleTheme,
    initTheme,
    watchSystemTheme,
  };
}
